export class UserAgreementModel {
	agreement_id: string;
	title: string;
	body: string;
	completed: boolean;
}
